import { render, staticRenderFns } from "./PWstudioIntroduce.vue?vue&type=template&id=3f16fd6a&scoped=true&"
import script from "./PWstudioIntroduce.vue?vue&type=script&lang=js&"
export * from "./PWstudioIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./PWstudioIntroduce.vue?vue&type=style&index=0&id=3f16fd6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f16fd6a",
  null
  
)

component.options.__file = "PWstudioIntroduce.vue"
export default component.exports